import $ from 'jquery';
import { ajaxAlert } from '../ui/feedback.js';
import { displayToastrAlert } from '../ui/toastr-alert.js';
import { renameOrderRows } from '../ordering/validation.js';
import { customOrderText } from '../ordering/inventory.js';
import { escapeHtml } from '../core/utilities.js';

/**
 * Line items for quick-order / multi-order-table (values read directly so disabled
 * fields and missing name= still post — jQuery .serialize() omits disabled inputs).
 */
function collectMultiOrderLineItems($form) {
    var items = [];
    $form.find('.multi-order-table tbody tr').each(function () {
        var $tr = $(this);
        if ($tr.hasClass('default-row')) {
            return;
        }
        var aaia = String($tr.find('.multi-order-brand').val() || '').trim();
        var pn = String($tr.find('.multi-order-part-number').val() || '').trim();
        var qtyRaw = $tr.find('.multi-order-quantity').val();
        var qty =
            qtyRaw != null && String(qtyRaw).trim() !== ''
                ? String(qtyRaw).trim()
                : '1';
        if (!aaia || !pn) {
            return;
        }
        items.push({
            AAIABrandCode: aaia,
            PartNumber: pn,
            Quantity: qty,
        });
    });
    return items;
}

function serializedFormHasMultiOrderItems(data) {
    return /(^|&)(items)(%5B|\[)0(%5D|\])/.test(data);
}

/**
 * POST to .../add_item_to_order/ can 301 to .../add_item_to_order; following the
 * redirect as GET drops the body — strip a terminal slash on the bare endpoint only.
 */
function ajaxUrlWithoutTrailingAddItemSlash(url) {
    if (!url || url.indexOf('add_item_to_order') === -1) {
        return url;
    }
    return url.replace(/(add_item_to_order)\/+(?=[?#]|$)/, '$1');
}

export function initAjaxForm() {
    $(document).on('submit', '.ajax-form', function (e) {
        e.preventDefault();
        var $form = $(this);
        var $alertElement = $form.find('.ajax-alert');
        var $submitButton = $form.find('[type="submit"]');
        var $brand = $form.find('#OrderBrand');
        var $partNumber = $form.find('#PartNumber');
        var originalButtonText = '';
        var singleOrderMode = $form.attr('data-single-order') === '1';
        var redirectAfterOrdering = $form.attr('data-order-redirect') === '1';
        var viewAs = $form.attr('data-view-as');

        if ($form.attr('action').indexOf('record_lost_sale') !== -1) {
            if ($form.find('#LostSaleReasonRowID').val() !== '') {
                var lostSaleData = {
                    'lost_sale[LostSaleReasonRowID]': $form
                        .find('#LostSaleReasonRowID')
                        .val(),
                    'lost_sale[Note]': $form.find('#Note').val(),
                };
                if (
                    $form.find(
                        '[data-lost-sale-stock-notification]:not(.d-none) [name="notify_when_in_stock"]:checked'
                    ).length
                ) {
                    lostSaleData.notify_when_in_stock = '1';
                }
                $.post(
                    $form.attr('action'),
                    lostSaleData,
                    function (result) {
                        var response = result;
                        if (typeof response === 'string') {
                            try {
                                response = JSON.parse(response);
                            } catch {
                                // Existing endpoints may answer non-JSON truthy text. Preserve
                                // that success contract while understanding the new partial-
                                // failure object when it arrives as a plain response body.
                            }
                        }

                        if (response !== false) {
                            ajaxAlert(
                                $alertElement,
                                'The lost sale has been added.'
                            );
                            if (
                                response &&
                                typeof response === 'object' &&
                                response.stock_notification === false
                            ) {
                                displayToastrAlert(
                                    'warning',
                                    'The lost sale was added, but the stock notification could not be saved. Please try again from the item page.'
                                );
                            }
                        }

                        $form
                            .closest('.modal')
                            .find('[type="submit"]')
                            .attr('disabled', 'disabled');
                    }
                );
            }

            return true;
        }

        var validSubmission = true;

        if ($form.attr('action').indexOf('add_item_to_order') !== -1) {
            var invalidBrand =
                $brand.length && $brand.val().trim().length === 0;
            var invalidPartNumber =
                $partNumber.length && $partNumber.val().trim().length === 0;

            if (!singleOrderMode && (invalidBrand || invalidPartNumber)) {
                validSubmission = false;
            }
        }

        if (!validSubmission) {
            return false;
        }

        var postData = $form.serialize();
        if ($form.attr('action').indexOf('add_item_to_order') !== -1) {
            $form.find('.multi-order-table').each(function () {
                renameOrderRows($(this));
            });
            postData = $form.serialize();
            var lineItems = collectMultiOrderLineItems($form);
            if (
                lineItems.length &&
                !serializedFormHasMultiOrderItems(postData)
            ) {
                postData +=
                    (postData.length ? '&' : '') + $.param({ items: lineItems });
            }
        }

        var $instantOrderButton = $form.find('.instant-order');

        $.ajax({
            url: ajaxUrlWithoutTrailingAddItemSlash($form.attr('action')),
            data: postData,
            type: $form.attr('method'),
            dataType: 'json',
            beforeSend: function () {
                if ($instantOrderButton.length) {
                    $instantOrderButton.prop('disabled', true);
                }

                originalButtonText = $submitButton.text();

                $submitButton
                    .html(
                        '<i class="fa fa-circle-o-notch fa-spin"></i><span class="visually-hidden">Loading...</span> Submitting...'
                    )
                    .prop('disabled', true);
            },
            complete: function (response) {
                if (!response.hasOwnProperty('responseJSON')) {
                    return false;
                }

                if ($instantOrderButton.length) {
                    $instantOrderButton.prop('disabled', true);
                }

                $submitButton.text(originalButtonText).prop('disabled', true);

                var data = response.responseJSON;

                // add_item_to_order() initialises action/order_id/error and returns all
                // three, so hasOwnProperty() is always true - the failure has to be read
                // off data.error and the values themselves. Caught in review on #486.
                if (data.error || !data.action || data.order_id == null) {
                    console.error('Could not submit order', data);
                    displayToastrAlert(
                        'error',
                        data.error || 'That item could not be added. Please try again.'
                    );
                    // re-enabled here because the early return skips the paths that
                    // normally do it, leaving the button dead
                    $submitButton.text(originalButtonText).prop('disabled', false);
                    if ($instantOrderButton.length) {
                        $instantOrderButton.prop('disabled', false);
                    }
                    return false;
                }

                var action = data.action;
                var orderId = data.order_id;

                if (reloadIfOnOrderPage(orderId) !== false) {
                    return true;
                }

                if (redirectAfterOrdering) {
                    window.location.href =
                        '/order/view/' +
                        orderId +
                        (viewAs != '' ? '?au=' + viewAs : '');
                    return true;
                }

                if (singleOrderMode) {
                    var orderText =
                        customOrderText &&
                        String(customOrderText).trim() !== ''
                            ? customOrderText
                            : 'order';
                    var message =
                        action === 'updated'
                            ? 'Item quantity updated'
                            : 'Added item to ' + orderText;
                    var orderIdStr =
                        orderId != null && String(orderId) !== ''
                            ? String(orderId)
                            : '';
                    if (orderIdStr !== '') {
                        var viewAsParam =
                            viewAs != null && String(viewAs).length > 0
                                ? '?au=' + encodeURIComponent(String(viewAs))
                                : '';
                        var orderViewHref =
                            'order/view/' + orderIdStr + viewAsParam;
                        var viewOrderLabel = 'Go to ' + orderText;
                        var toastHtml =
                            '<div class="pace-order-toast text-start">' +
                            '<p class="mb-2 mb-md-2 small">' +
                            message +
                            '</p>' +
                            '<a href="' +
                            orderViewHref +
                            '" class="btn btn-sm btn-primary">' +
                            viewOrderLabel +
                            '</a></div>';

                        displayToastrAlert('success', message, false, {
                            html: toastHtml,
                            dedupeExtra: orderIdStr,
                        });
                    } else {
                        displayToastrAlert('success', message);
                    }

                    $form.trigger('orderAdded', [action, data]);

                    setTimeout(function () {
                        $instantOrderButton.prop('disabled', false);
                        $submitButton.prop('disabled', false);
                    }, 3000);

                    return true;
                }

                var selectedOrderId = $form.find('[name="OrderRowID"]').val();

                $form.find('tr').not('.default-row').remove();

                $form.find('[name="OrderRowID"]').val('');

                $form
                    .find('.js-input-order-name')
                    .val('')
                    .closest('.mb-3')
                    .show();

                var orderString = '';

                if (action === 'added' && selectedOrderId.length > 0) {
                    orderString =
                        'The product has been added to ' +
                        // ajaxAlert() injects this with .html(), so the order name - which the
                        // customer typed - is escaped on the way in
                        escapeHtml(
                            $form
                                .find(
                                    '[name="OrderRowID"] option[value="' +
                                        selectedOrderId +
                                        '"]'
                                )
                                .text()
                        ) +
                        '. <a href="order/view/' +
                        selectedOrderId +
                        (viewAs != '' ? '?au=' + viewAs : '') +
                        '" target="_blank">Click here to view this ' +
                        customOrderText +
                        '.</a>';
                } else if (action === 'added') {
                    orderString =
                        'The product has been added to a new ' +
                        customOrderText +
                        '.';
                    if (orderId != null && String(orderId) !== '') {
                        orderString +=
                            ' <a href="order/view/' +
                            String(orderId) +
                            (viewAs != null && String(viewAs).length > 0
                                ? '?au=' + encodeURIComponent(String(viewAs))
                                : '') +
                            '" class="alert-link">View this ' +
                            customOrderText +
                            '.</a>';
                    }

                    $('.label-orders-count').each(function () {
                        var orderCount = parseInt($(this).text());
                        $(this).text(++orderCount);
                    });
                } else if (action === 'updated' && selectedOrderId.length > 0) {
                    orderString =
                        "The product's quantity has been updated for " +
                        customOrderText +
                        ' ' +
                        escapeHtml(
                            $form
                                .find(
                                    '[name="OrderRowID"] option[value="' +
                                        selectedOrderId +
                                        '"]'
                                )
                                .text()
                        ) +
                        '. <a href="order/view/' +
                        selectedOrderId +
                        (viewAs != '' ? '?au=' + viewAs : '') +
                        '" target="_blank">Click here to view this ' +
                        customOrderText +
                        '.</a>';
                }

                populateCurrentOrdersDropdown();

                ajaxAlert($alertElement, orderString);
            },
        });
    });
}

export function reloadIfOnOrderPage(orderId) {
    var pathArray = window.location.pathname.split('/');

    if (pathArray.length < 4) {
        return false;
    }

    if (pathArray[1] !== 'order') {
        return false;
    }

    // 'submit' was here for /order/submit/<id>, a path no controller method ever backed
    if (pathArray[2] !== 'view') {
        return false;
    }

    if (typeof orderId === 'undefined') {
        return false;
    }

    if (orderId == pathArray[3]) {
        window.location.reload();
    } else {
        window.location.href = '/order/' + pathArray[2] + '/' + orderId;
    }

    return true;
}

export function populateCurrentOrdersDropdown() {
    $.ajax({
        url: 'order/get_current_orders',
        dataType: 'json',
        success: function (orders) {
            if (orders != null) {
                var output =
                    '<option value="">-- Add New ' +
                    escapeHtml(customOrderText) +
                    ' --</option>';

                $('.order-dropdown').each(function () {
                    var $dropdown = $(this);
                    var selected = $dropdown.val();

                    $dropdown.html(output);

                    // Built with DOM APIs rather than concatenated markup: OrderName is free text the
                    // customer types, and .html() would parse it. See issue #129.
                    for (var i = 0; i < orders.length; i++) {
                        $dropdown.append(
                            $('<option>').val(orders[i].RowID).text(orders[i].OrderName)
                        );
                    }

                    $dropdown.val(selected);
                });
            }
        },
    });
}
